import Base from '../Base';
import Swiper from 'swiper';
export default class Covid extends Base {
    init(id, elMain, locale) {
        console.log(':: COVID PAGE ::');

        const main = document.querySelector('main#covid');
        const modal = document.querySelector('.covid-modal');
        const modalBg = modal.querySelector('.bg');
        const modalCloseBtns = modal.querySelectorAll('.close-btn');

        initTimeline();
        addCardsListeners();

        modalBg.addEventListener('click', closeModal);
        for (let i = 0; i < modalCloseBtns.length; i++) {
            modalCloseBtns[i].addEventListener('click', closeModal);
        }

        // Swiper for publications
        const publicationsSwiper = new Swiper('.swiper-publications', {
            autoHeight: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                formatFractionCurrent(number) {
                    return number < 10 ? `0${number}` : number;
                },
                formatFractionTotal(number) {
                    return number < 10 ? `0${number}` : number;
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        function initTimeline() {
            setTimeout(()=>{
                const timelineDates = new Swiper('.timeline-dates', {
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    slideToClickedSlide: true,
                    threshold: 15,
                });
                const timelineContents = new Swiper('.timeline-contents', {
                    grabCursor: true,
                    spaceBetween: 10,
                    autoHeight: true,
                    speed: 700,
                    centeredSlides: true,
                    slidesPerView: 1,
                    effect: 'fade',
                });

                timelineDates.controller.control = timelineContents;
                timelineContents.controller.control = timelineDates;
            }, 300);
        }

        function addCardsListeners() {
            const cards = main.querySelectorAll('.card');

            if (cards.length) {
                for (let i = 0; i < cards.length; i++) {
                    cards[i].addEventListener('click', onCardClick);
                }
            }
        }

        function onCardClick(e) {
            const target = e.currentTarget;
            const contentType = target.dataset.type;
            modal.querySelector('.title').innerHTML = target.querySelector('.subtitle').innerHTML;
            modal.querySelector('.subtitle').innerHTML = target.querySelector('.title').innerHTML;
            if (contentType == 'text' || contentType == 'video' || contentType == 'graph') {
                modal.querySelector('.wysiwyg-container').innerHTML = target.querySelector('.content').innerHTML;

                var els = document.getElementsByClassName('graphImgContainer');

                Array.from(els).forEach(el => {
                    el.addEventListener('scroll', () => {
                        el.classList.add('scrollGraph');
                    });
                });
            }
            showModal();
        }

        function showModal() {
            modal.style.display = 'flex';
        }

        function closeModal() {
            modal.style.display = 'none';
            modal.querySelector('.wysiwyg-container').innerHTML = '';
        }
    }
}